@file:Suppress("unused")

package com.exura.features.storage.domain


sealed class StorageException(message: String, cause: Throwable? = null) : Exception(message, cause)


class EntityNotFoundException(id: String) : StorageException("Entity with id '$id' not found")


class EntityAlreadyExistsException(id: String) : StorageException("Entity with id '$id' already exists")


class ValidationException(message: String) : StorageException("Validation failed: $message")


class StorageOperationException(message: String, cause: Throwable? = null) : StorageException(message, cause)
